import React from 'react';
import AppRoutes from '../routes';
import Header from '../components/fitbae/layouts/header';
import Footer from '../components/fitbae/layouts/footer';
import HomePage from '../pages/fitbae/home_page';
import AboutPage from '../pages/ncici/about_page';


export default function FitBaeTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                aboutPage={AboutPage}
            />
            <Footer />
        </React.Fragment>
    )
}